// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
export const API_TIMEOUT = 30000; // 30 segundos

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: '@maralabs:token',
  USER_DATA: '@maralabs:user',
  REFRESH_TOKEN: '@maralabs:refresh_token',
  THEME: '@maralabs:theme',
  TENANT_ID: '@maralabs:tenant_id',
};

// Routes
export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CONVERSATIONS: '/dashboard/conversations',
  OVERVIEW: '/dashboard/overview',
  TENANTS: '/dashboard/tenants',
  SETTINGS: '/dashboard/settings',
  PROFILE: '/dashboard/profile',
};

// Conversation Status
export const CONVERSATION_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  TRANSFERRED: 'transferred',
};

export const CONVERSATION_STATUS_LABELS = {
  [CONVERSATION_STATUS.PENDING]: 'Pendente',
  [CONVERSATION_STATUS.IN_PROGRESS]: 'Em Andamento',
  [CONVERSATION_STATUS.RESOLVED]: 'Resolvida',
  [CONVERSATION_STATUS.TRANSFERRED]: 'Transferida',
};

export const CONVERSATION_STATUS_COLORS = {
  [CONVERSATION_STATUS.PENDING]: 'warning',
  [CONVERSATION_STATUS.IN_PROGRESS]: 'info',
  [CONVERSATION_STATUS.RESOLVED]: 'success',
  [CONVERSATION_STATUS.TRANSFERRED]: 'primary',
};

// Contact Reasons
export const CONTACT_REASONS = {
  SUPPORT: 'support',
  SALES: 'sales',
  INFORMATION: 'information',
  COMPLAINT: 'complaint',
  OTHER: 'other',
};

export const CONTACT_REASON_LABELS = {
  [CONTACT_REASONS.SUPPORT]: 'Suporte Técnico',
  [CONTACT_REASONS.SALES]: 'Vendas',
  [CONTACT_REASONS.INFORMATION]: 'Informação',
  [CONTACT_REASONS.COMPLAINT]: 'Reclamação',
  [CONTACT_REASONS.OTHER]: 'Outros',
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  ITEMS_PER_PAGE_OPTIONS: [10, 20, 50, 100],
};

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'DD/MM/YYYY',
  DISPLAY_WITH_TIME: 'DD/MM/YYYY HH:mm',
  API: 'YYYY-MM-DD',
  TIME: 'HH:mm',
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  AGENT: 'agent',
  CLIENT: 'client',
};

// Notification Types
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

// Request Status
export const REQUEST_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

// Filter Options
export const FILTER_OPTIONS = {
  ALL: 'all',
  TODAY: 'today',
  WEEK: 'week',
  MONTH: 'month',
  CUSTOM: 'custom',
};

// Mara Labs Brand Colors
export const BRAND_COLORS = {
  PRIMARY: '#4FD1C5',
  SECONDARY: '#38B2AC',
  DARK: '#2C7A7B',
  SUCCESS: '#22C55E',
  WARNING: '#F59E0B',
  DANGER: '#EF4444',
  INFO: '#3B82F6',
};

// App Config
export const APP_CONFIG = {
  NAME: 'Mara Labs Dashboard',
  VERSION: '1.0.0',
  DESCRIPTION: 'Plataforma de Gestão de Automações',
  SUPPORT_EMAIL: 'suporte@maralabs.com.br',
  SUPPORT_PHONE: '(98) 98888-8888',
};